import { useEffect, useRef } from 'react';

/**
 * Periodično osvežavanje koje staje kad niko ne gleda.
 *
 * Panel podrške nema SSE kanal kao kasa: EventSource ne ume da pošalje
 * `Authorization` header, pa bi token morao u URL - a sysadmin token otvara celu
 * platformu i u URL-u završava po logovima. Za konzolu koju gleda jedan ili dvoje
 * ljudi anketiranje je pošteniji izbor od te razmene.
 *
 * Pauzira se kad je kartica skrivena i nadoknađuje čim se vrati - inače bi
 * otvoren tab u pozadini danima kucao na server bez ijednog gledaoca.
 */
export function useLivePoll(fn: () => void | Promise<void>, intervalMs: number, enabled = true) {
  const saved = useRef(fn);
  saved.current = fn;

  useEffect(() => {
    if (!enabled) return;

    let timer: ReturnType<typeof setInterval> | null = null;

    const tick = () => { void saved.current(); };

    const start = () => {
      if (timer) return;
      timer = setInterval(tick, intervalMs);
    };
    const stop = () => {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    };

    const onVisibility = () => {
      if (document.hidden) { stop(); return; }
      // Povratak na karticu odmah dovlači ono što je propušteno.
      tick();
      start();
    };

    if (!document.hidden) start();
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [intervalMs, enabled]);
}
